import { createContext, useEffect, useState } from "react";

export const AppContext = createContext();

export default function AppProvider({ children }) {

    const [token, setToken] = useState(localStorage.getItem('token'));
    const [user, setUser] = useState(null);

    // حالات البوب أب
    const [showLogin, setShowLogin] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [showForget, setShowForget] = useState(false);
    const [showEditProfile, setShowEditProfile] = useState(false);


    async function getUser() {
        try {
            const res = await fetch('https://dashboard.tiktaka.com/api/user', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await res.json();
            console.log('====================================');
            console.log('user !!');
            console.log(data);
            console.log('====================================');

            setUser(data);

        } catch (error) {
            console.log('====================================');
            console.log('error :');
            console.log(error);
            console.log('====================================');
        }
    }

    useEffect(() => {
        console.log('====================================');
        console.log('Effect Ran!!');
        console.log('====================================');

        if (token) {
            getUser();
        }

    }, [token]);

    return (
        <AppContext.Provider value={{
            token, setToken,
            user, setUser,
            showLogin, setShowLogin,
            showRegister, setShowRegister,
            showForget, setShowForget,
            showEditProfile, setShowEditProfile,
        }}>
            {children}
        </AppContext.Provider>
    );
}
